<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g>
      <path
        fill="none"
        stroke="#fff"
        stroke-width="4.3912"
        stroke-miterlimit="4"
        stroke-linecap="butt"
        stroke-linejoin="miter"
        d="M16 31.991l0.065-16.056-16.056 0.065"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-width="4.3912"
        stroke-miterlimit="4"
        stroke-linecap="butt"
        stroke-linejoin="miter"
        d="M16 0.009l-0.065 16.056 16.056-0.065"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
